export default __webpack_public_path__ + "static/open-graph 1200x630-740525762e94a40573192e54608b008c.png";